import { render, staticRenderFns } from "./ReprintPayment.vue?vue&type=template&id=8d2f0618&scoped=true"
import script from "./ReprintPayment.vue?vue&type=script&lang=js"
export * from "./ReprintPayment.vue?vue&type=script&lang=js"
import style0 from "./ReprintPayment.vue?vue&type=style&index=0&id=8d2f0618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2f0618",
  null
  
)

export default component.exports